export const chargeColumns = [
  {
    title: '温层',
    dataIndex: 'temperatureLayerName',
  },
  {
    title: '可租面积',
    dataIndex: 'availableArea',
  },
  {
    title: '计费方式',
    dataIndex: 'chargeType',
  },
  // {
  //   title: '租金价格',
  //   dataIndex: 'price',
  //   // customRender: (text) => `${text}元/托/天`,
  //   scopedSlots: { customRender: 'price' },
  // },
]

export const businessColumns = [
  {
    title: '温层',
    dataIndex: 'temperatureLayerName',
  },
  {
    title: '面积',
    dataIndex: 'area',
  },
  {
    title: '制冷区间',
    dataIndex: 'temperature',
    customRender: (text, cell) => `${cell.minTemperature || '0'}°C~${cell.maxTemperature || '0'}°C`,
  },
  {
    title: '计费方式',
    dataIndex: 'chargeType',
  },
]

export const regionalList = [
  {
    label: '华北',
    value: 'huabei',
    provinceList: ['北京市', '天津市', '河北省', '山西省', '内蒙古自治区'],
  },
  {
    label: '华东',
    value: 'huadong',
    provinceList: ['上海市', '江苏省', '浙江省', '山东省', '安徽省'],
  },
  {
    label: '东北',
    value: 'dongbei',
    provinceList: ['辽宁省', '吉林省', '黑龙江省'],
  },
  {
    label: '华中',
    value: 'huazhong',
    provinceList: ['湖北省', '湖南省', '河南省', '江西省'],
  },
  {
    label: '华南',
    value: 'huanan',
    provinceList: ['广东省', '广西壮族自治区', '海南省', '福建省'],
  },
  {
    label: '西南',
    value: 'xinan',
    provinceList: ['四川省', '重庆市', '贵州省', '云南省', '西藏自治区'],
  },
  {
    label: '西北',
    value: 'xibei',
    provinceList: ['陕西省', '甘肃省', '新疆维吾尔自治区', '青海省', '宁夏回族自治区'],
  }
]
export const TEMPERATURES = [
  {
    value: "常温",
    label: "常温",
  },
  {
    value: "冷藏",
    label: "冷藏",
  },
  {
    value: "冷冻",
    label: "冷冻",
  },
  {
    value: "恒温",
    label: "恒温",
  },
];
export const baseInfoField = [
  {
    label: '仓库面积',
    prop: 'area',
    slot: 'area'
  },
  {
    label: '仓库类型',
    prop: 'storehouseType',
    optionsProp: 'warehouseType',
    options: []
  },
  {
    label: '配套设施',
    prop: 'partEquipments',
    optionsProp: 'partEquipments',
    options: []
  },
  {
    label: '硬件设备设施',
    prop: 'wareEquipments',
    optionsProp: 'wareEquipments',
    options: []
  },
  {
    label: '安保设备',
    prop: 'safeEquipments',
    optionsProp: 'safeEquipments',
    options: []
  },
  {
    label: '消防等级',
    prop: 'fireWareLevel',
    optionsProp: 'fireRatingOption',
    options: []
  },
  {
    label: '资质',
    prop: 'authenticationPicture',
    optionsProp: 'qualificationOption',
    options: []
  },
]

// 云仓供应商业务选项
export const yuncangList = [
  {
    label: '不限',
    value: undefined
  },
  {
    label: '是',
    value: '1',
  },
  {
    label: '否',
    value: '0'
  }
]